// recuperacao-02 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Enviar SMS (em breve)": "Enviar SMS (próximamente)",
    "Enviar WhatsApp (em breve)": "Enviar WhatsApp (próximamente)",
};

export default catalogo;
